// export const lhwpath = `http://localhost:5001`;

export const chawlaispat = `https://chawlaispat.com`

// API ka base URL.
//
// Netlify par site apne hi origin se API call karti hai: public/_redirects
// /global, /auth aur /imageService ko seedha DigitalOcean wali API par proxy
// kar deta hai. Isse CORS bhi khatam aur lohawalla.com ka extra hop bhi.
// netlify.toml me REACT_APP_SAME_ORIGIN_API = "true" set hai.
//
// Android (Capacitor) build me yeh var set nahi hota. Wahan page
// capacitor://localhost se load hota hai, to relative URL kaam hi nahi karega —
// isliye default absolute URL hi rehta hai.
//
// REACT_APP_API_BASE se kisi bhi build me alag backend point kiya ja sakta hai
// (jaise local ya staging).
export const lhwpath =
  process.env.REACT_APP_SAME_ORIGIN_API === "true"
    ? ``
    : process.env.REACT_APP_API_BASE || `https://lohawalla.com`;
